<template>
  <div v-if="items && items.length > 0">
    <h4
      class="border-y border-b-neutral-200 border-t-neutral-100 bg-neutral-50 pl-6 pr-3 py-1.5 text-sm/6 font-semibold text-neutral-900"
      v-if="title"
    >
      {{ title }}
    </h4>
    <ul role="list" class="divide-y divide-neutral-200">
      <li v-for="item in items" :key="item.id" class="group block hover:bg-sky-100 last-of-type:rounded-b-md">
        <router-link :to="item.to" class="block">
          <div class="flex items-center px-4 py-4 sm:px-6">
            <div class="flex min-w-0 flex-1 items-center">
              <slot name="default" :item="item"> </slot>
            </div>
            <div>
              <ChevronRightIcon
                class="z-0 h-6 w-6 text-neutral-300 transition-transform ease-in group-hover:translate-x-1 group-hover:text-neutral-500"
                aria-hidden="true"
              />
            </div>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
// Note: When updating this description - you must also update the md file.

/** A list of entities that can be displayed in a landing card. */
export default { name: "LandingCardEntityList" };
</script>

<script setup lang="ts" generic="T extends LandingCardEntityBase">
import { ChevronRightIcon } from "@heroicons/vue/24/outline";
import type { LandingCardEntityBase } from "@/components/landing/landingCard";

const props = defineProps<{
  title?: string;
  items: T[] | undefined;
}>();
</script>
